import AccordionComponent from "../ui-kit/accordion/Accordion";
import Markdown from "markdown-to-jsx";
import AttachmentImage from "../ui-kit/attachment/AttachmentImage";
import UploadButton from "../edit-profile/UploadButton";

export const ASUtils = {
  renderDocument: (isWire, currentDocument, currentAccount) => {
    if (currentDocument?.format === "MARKUP") {
      const forWireTitle = `## Funding Your Account \n`;

      // Define the Beneficiary Note
      const beneficiaryNote = `<br>Beneficiary Note: ${
        currentAccount?.reference?.client || "N/A"
      }`;
      const additionalLine = `<br><span style="font-size: smaller;">* must be included in the transfer to avoid delays in processing</span>`;

      const modifiedBody = currentDocument?.body.replace(
        /Beneficiary Address:.*\n/,
        (match) => `${match.trim()}${beneficiaryNote}${additionalLine}`
      );

      return (
        <Markdown
          children={`${isWire ? forWireTitle : ""} ${modifiedBody}` || ""}
          options={{
            overrides: {
              Accordion: {
                component: AccordionComponent,
              },
              img: {
                component: AttachmentImage,
                props: {
                  currentDocument: currentDocument?.id,
                },
              },
            },
          }}
        />
      );
    } else return currentDocument?.body || "";
  },

  renderWireSentClicked: (
    wireImage,
    isPDF,
    onRemoveClick,
    onChangeClick,
    onYesClick,
    onCancelClick,
    setNewImageUploaded,
    setPopupState
  ) => {
    return (
      <div className="wire-opened-dialog">
        <div className="black-block" />
        <div className="wire-dialog-block">
          <header>Wire Confirmation</header>
          <div className="wire-dialog">
            <span>Do you confirm that a wire was sent?</span>
            <hr />
            {wireImage && (
              <div className="wire-image-block">
                <img
                  className="wire-image pad-btn"
                  src={
                    isPDF
                      ? `${process.env.PUBLIC_URL}/pdf-icon.png`
                      : wireImage.image
                  }
                  alt="wire"
                />
                <div className="wire-image-buttons">
                  <button
                    className="wire-button upload-wire-button"
                    onClick={() => onRemoveClick(true)}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/close-red.png`}
                      alt="close"
                    />
                    Remove
                  </button>
                  <button
                    className="wire-button upload-wire-button"
                    onClick={onChangeClick}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/open-folder.png`}
                      alt="open"
                    />
                    Change
                  </button>
                </div>
              </div>
            )}
            <UploadButton
              show={!wireImage}
              setNewImageUploaded={setNewImageUploaded}
              actionType="fee"
              setPopupState={setPopupState}
            />
            <hr />
          </div>
          <div className="wire-dialog-bottom-buttons fixed-button-size">
            <button
              id="wire-confirm-button-2"
              className="wire-button"
              onClick={onYesClick}
            >
              Yes, confirm
            </button>
            <button
              id="wire-cancel-button-2"
              className="wire-button wire-button-transparent"
              onClick={() => onCancelClick(true)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  },

  renderWireWordClicked: (
    wireImage,
    isPDF,
    onRemoveClick,
    onCancelClick,
    setNewImageUploaded,
    setPopupState,
    getWireSentStatusDate
  ) => {
    return (
      <div className="wire-opened-dialog">
        <div className="black-block" />
        <div className="wire-dialog-block">
          <header>Wire Confirmation</header>
          <div className="wire-dialog">
            <span className="wire-dialog-subheader">
              You confirmed the wire was sent{" "}
            </span>
            <span>{getWireSentStatusDate()}</span>
            <hr />
            {wireImage && (
              <div className="wire-image-block">
                <img
                  className="wire-image"
                  src={
                    isPDF
                      ? `${process.env.PUBLIC_URL}/pdf-icon.png`
                      : wireImage.image
                  }
                  alt="wire"
                />
              </div>
            )}
            <UploadButton
              show={!wireImage}
              setNewImageUploaded={setNewImageUploaded}
              actionType="fee"
              setPopupState={setPopupState}
            />
            <hr />
            <span>
              If you did not send this wire or would like to change any
              information, please click below to start over.
            </span>
          </div>
          <div className="wire-dialog-bottom-buttons">
            <button
              className="wire-button wire-button-red"
              onClick={() => onRemoveClick(false)}
            >
              Remove Wire Confirmation
            </button>
            <button
              className="wire-button wire-button-transparent"
              onClick={() => onCancelClick(false)}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    );
  },
};
